/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to update a document folder template.
 * @export
 * @interface UpdateDocumentFolderTemplateRequest
 */
export interface UpdateDocumentFolderTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentFolderTemplateRequest
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDocumentFolderTemplateRequest
     */
    parentId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentFolderTemplateRequest
     */
    color?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDocumentFolderTemplateRequest
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the UpdateDocumentFolderTemplateRequest interface.
 */
export function instanceOfUpdateDocumentFolderTemplateRequest(value: object): value is UpdateDocumentFolderTemplateRequest {
    return true;
}

export function UpdateDocumentFolderTemplateRequestFromJSON(json: any): UpdateDocumentFolderTemplateRequest {
    return UpdateDocumentFolderTemplateRequestFromJSONTyped(json, false);
}

export function UpdateDocumentFolderTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDocumentFolderTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'color': json['color'] == null ? undefined : json['color'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function UpdateDocumentFolderTemplateRequestToJSON(json: any): UpdateDocumentFolderTemplateRequest {
    return UpdateDocumentFolderTemplateRequestToJSONTyped(json, false);
}

export function UpdateDocumentFolderTemplateRequestToJSONTyped(value?: UpdateDocumentFolderTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'parentId': value['parentId'],
        'color': value['color'],
        'isActive': value['isActive'],
    };
}

